import {Loader} from "@googlemaps/js-api-loader"
import marker from "../../assets/svg/marker.svg"
import trees from "../../assets/svg/trees.svg"
import x from '../../assets/svg/close.svg'
import goTo from '../../assets/svg/map-go-to.svg'

import './style.css';

export default class OurPropertiesListMap {
    static selector = '.op-list-page-map';

    constructor(block) {
        this.block = block;
        this.propertiesList = document.querySelector('.op-list-page');
    }

    initMap() {
        this.mapLoader = new Loader({
            apiKey: process.env.GOOGLE_MAPS_API_KEY,
            version: "weekly",
        });

        this.mapLoader.load().then(() => {
            class Popup extends google.maps.OverlayView {
                constructor(position, content) {
                    super();
                    this.position = position
                    const bubbleAnchor = document.createElement("div");
                    bubbleAnchor.classList.add("popup-bubble-anchor");
                    bubbleAnchor.appendChild(content);
                    this.containerDiv = document.createElement("div");
                    this.containerDiv.classList.add("popup-container");
                    this.containerDiv.appendChild(bubbleAnchor);
                    Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
                }

                onAdd() {
                    this.getPanes().floatPane.appendChild(this.containerDiv);
                }

                onRemove() {
                    if (this.containerDiv.parentElement) {
                        this.containerDiv.parentElement.removeChild(this.containerDiv);
                    }
                }

                draw() {
                    const divPosition = this.getProjection().fromLatLngToDivPixel(
                        this.position
                    );
                    // Hide the popup when it is far out of view.
                    const display =
                        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                            ? "block"
                            : "none";

                    if (display === "block") {
                        this.containerDiv.style.left = divPosition.x + "px";
                        this.containerDiv.style.top = divPosition.y + "px";
                    }

                    if (this.containerDiv.style.display !== display) {
                        this.containerDiv.style.display = display;
                    }
                }
            }

            this.PopupClass = Popup;

            this.updateMap();
        })
    }

    updateMap = () => {
        const positions = this.prepareMarkersPositions();

        const bounds = new google.maps.LatLngBounds();
        const map = new google.maps.Map(this.block);

        positions.forEach(position => {
            if (!isNaN(position.lng) && !isNaN(position.lat)) {
                const tempMarker = new google.maps.Marker({
                    position: position,
                    icon: marker,
                    map: map,
                });

                tempMarker.addListener('click', () => {
                    this.pop ? this.pop.onRemove() : null;
                    this.pop = new this.PopupClass(
                        new google.maps.LatLng(position.lat, position.lng),
                        this.preparePopup(position.lat, position.lng),
                    );
                    map.setCenter(new google.maps.LatLng(position.lat, position.lng))
                    this.pop.setMap(map);
                });

                bounds.extend(position);
            }
        })

        map.fitBounds(bounds);
    }

    preparePopup(lat, lng) {
        const {title, image, location, link} = this.propertiesList.querySelector(`article[data-lat="${lat}"][data-lng="${lng}"]`).dataset;
        const wrapper = document.createElement('div');
        wrapper.classList.add('map-popup');
        const imageBox = image
            ? `<img src="${image}" class="map-popup__img" />`
            : `<div class="map-popup__img-placeholder"><div class="img-placeholder"><img src="${trees}" class="map-popup__svg"/></div></div>`;
        wrapper.innerHTML = `
            <button class="map-popup__x"><img src="${x}"/></button>
            ${imageBox}
            <a href="${link}">
                <div class="map-popup__box">
                    <h2 class="map-popup__title">${title}</h2>
                    <p class="map-popup__location">${location}</p>
                    <img src="${goTo}" class="map-popup__goto" />
                </div>
            </a>
        `;

        wrapper.querySelector('.map-popup__x').addEventListener('click', () => {
            this.pop ? this.pop.onRemove() : null;
        });

        return wrapper;
    }

    prepareMarkersPositions() {
        return Array
            .from(this.propertiesList.querySelectorAll('.property-preview'))
            .map(property => ({
                lat: parseFloat(property.dataset.lat),
                lng: parseFloat(property.dataset.lng),
            }));
    }

    onComplete() {
        this.initMap();
    }
}
